export enum OrderConfirmationAnalyticsMessages {
  capability = 'orders',
  event = 'share print download',
  // Append the file extension to the downloadType during runtime
  downloadType = 'download:order:',
  additionalInfoClick = 'additional info click',
}
